var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('LeftNavBar',{attrs:{"title":_vm.selectedAppInitial,"items":_vm.navItems,"selectedValue":_vm.selectedNavItem},on:{"opened":_vm.onNavClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }